export enum HorizontalAlign {
    Center = 'Center',
    Right = 'Right',
    Left = 'Left',
};
